import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EyeIcon } from "@heroicons/react/24/outline";
import { useContext, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { CustomFieldsContext } from "../../../providers/CustomFieldsContextProvider";
import { WPQTIconButton } from "../../common/Button/Button";
import { LoadingOval } from "../../Loading/Loading";
import { CustomField } from "./components/CustomField/CustomField";
function CustomFields() {
    const { state: { loading, customFields }, } = useContext(CustomFieldsContext);
    const [isOpen, setIsOpen] = useState(false);
    if (loading) {
        return (_jsx("div", { className: "wpqt-flex wpqt-justify-center", children: _jsx(LoadingOval, { width: "36", height: "36" }) }));
    }
    if (customFields && customFields.length === 0) {
        return (_jsx("div", { className: "wpqt-text-center wpqt-font-semibold", children: __("No related custom fields created", "quicktasker") }));
    }
    if (!isOpen) {
        return (_jsx("div", { className: "wpqt-flex wpqt-justify-center", children: _jsx(WPQTIconButton, { text: __("Show custom fields", "quicktasker"), onClick: () => setIsOpen(true), icon: _jsx(EyeIcon, { className: "wpqt-icon-blue wpqt-size-5" }) }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "wpqt-my-6 wpqt-grid wpqt-grid-cols-[100px_1fr_100px] wpqt-items-center wpqt-gap-3", children: customFields.map((customField) => (_jsx(CustomField, { data: customField }, customField.id))) }), _jsx("div", { className: "wpqt-flex wpqt-justify-center", children: _jsx(WPQTIconButton, { text: __("Close", "quicktasker"), onClick: () => setIsOpen(false), icon: _jsx(EyeIcon, { className: "wpqt-icon-red wpqt-size-5" }) }) })] }));
}
export { CustomFields };
